import { createContext, useContext } from "react";
import { UsePageFiltersReturnType } from "@/utils/usePageFIlters";

type SampleFilterContextType = UsePageFiltersReturnType | null;

export const SampleFilterContext = createContext<SampleFilterContextType>(null);
export const useSampleFilterContext = () => useContext(SampleFilterContext);
